import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiConfig } from "../config/api.config";

const DEPENDENCIAS = [
  "01 CONCEJO","02 PERSONERIA","03 JURIDICA","04 ALCALDIA","05 EDUCACION",
  "06 GOBIERNO","07 DESARROLLO Y BIENESTAR SOCIAL","08 PLANEACIÓN",
  "09 INFRAESTRUCTURA","10 HACIENDA","11 SERVICIOS ADMINISTRATIVOS",
  "12 SALUD","14 CULTURA","15 MOVILIDAD","16 INVICOP","17 JUNTA DE DEPORTES",
  "18 AGRICULTURA Y MEDIO AMBIENTE","20 CONTROL INTERNO","21 COMUNICACIONES",
  "22 CONTROL DISCIPLINARIO","23 DIRECCIÓN FINANCIERA",
];

const CENTROS_COSTOS = [
  "01001 CONCEJO","02001 PERSONERIA","03001 JURIDICA","04001 ALCALDIA",
  "05001 EDUCACION","05002 BIBLIOTECA MUNICIPAL","06001 GOBIERNO",
  "06002 INSPECCIÓN 1ra POLICIA","06006 INSPECCIÓN 2da DE POLICIA",
  "06007 INSPECCIÓN 3ra INFRACCIONES URBANISTICAS",
  "06008 INSPECCIÓN 4ta AFECTACIONES AMBIENTALES",
  "06003 COMISARIA DE FAMILIA NORTE","06009 COMISARIA DE FAMILIA SUR",
  "06004 FONSET","06005 GESTIÓN DEL RIESGO",
  "07001 DESARROLLO Y BIENESTAR SOCIAL","07002 VICTIMAS DE CONFLICTO",
  "07003 TURISMO","07004 JUVENTUD","07005 HABITANTE DE CALLE",
  "08001 PLANEACIÓN","08002 SISBEN","08003 CALIDAD","09001 INFRAESTRUCTURA",
  "10001 HACIENDA","10002 CATASTRO","11001 SERVICIOS ADMINISTRATIVOS",
  "11002 PERSONAL","11003 ALMACEN","11004 ARCHIVO","12001 SALUD",
  "12002 ADULTO MAYOR","12003 FONDO LOCAL DE SALUD",
  "12004 PLAN ALIMENTARIO ESCOLAR","14001 CULTURA","15001 MOVILIDAD",
  "16001 INVICOP","17001 JUNTA DE DEPORTES",
  "18001 AGRICULTURA Y MEDIO AMBIENTE","18002 ALBERGUE",
  "20001 CONTROL INTERNO","21001 COMUNICACIONES",
  "22001 CONTROL DISCIPLINARIO","23001 DIRECCIÓN FINANCIERA",
  "23002 COBRO COACTIVO",
];

const TIPOS_CONTRATO = [
  "1-Prestación de servicios persona natural o jurídica","2-Suministro",
  "3-Compraventa","4-Arrendamiento","5-Obra","6-Comodato",
  "7-Interadministrativo","8-Consultoría","9-Convenio","10-Seguros",
  "11-Servicios públicos","12-Transferencia","13-Subsidio",
  "14-Deuda - Entre otros","15- Caja Menor",
];

const emptyRubro = () => ({ disponibilidad: "", resumido_rubro: "", valor: "" });

export default function FormularioRPExtra() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    correo: "", tipo_contrato: "", dependencia: "",
    documento_beneficiario: "", nombre_beneficiario: "", objeto: "",
    numero_contrato_resolucion_factura: "",
    fecha_contrato_resolucion_factura: "",
    valor_total: "", centro_costos: "",
  });

  // Rubros: empieza con 1
  const [rubros, setRubros] = useState([emptyRubro()]);
  const [activeRubro, setActiveRubro] = useState(0);

  const [files, setFiles] = useState({ minuta_contrato: null, rut_beneficiario: null });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  const handleFile   = (e) => setFiles((prev) => ({ ...prev, [e.target.name]: e.target.files?.[0] || null }));

  const handleRubroChange = (idx, field, value) => {
    setRubros((prev) => prev.map((r, i) => i === idx ? { ...r, [field]: value } : r));
  };

  const addRubro = () => {
    if (rubros.length >= 9) return;
    setRubros((prev) => [...prev, emptyRubro()]);
    setActiveRubro(rubros.length);
  };

  const removeRubro = (idx) => {
    if (rubros.length === 1) return;
    setRubros((prev) => prev.filter((_, i) => i !== idx));
    setActiveRubro((prev) => Math.min(prev, rubros.length - 2));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const tempContractId = `OTRAS-CDP-RP-${Date.now()}`;

      // Aplanar rubros al formato original para compatibilidad con backend
      const rubrosFlat = {};
      rubros.forEach((r, i) => {
        const n = i + 1;
        rubrosFlat[`disponibilidad_${n}`]    = r.disponibilidad;
        rubrosFlat[`resumido_rubro_${n}`]    = r.resumido_rubro;
        rubrosFlat[`valor_${n}`]             = r.valor;
      });

      const payload = new FormData();
      payload.append("contract_id",      tempContractId);
      payload.append("contractId",       tempContractId);
      payload.append("request_type",     "RP");
      payload.append("source_module",    "otras_cdp_rp");
      payload.append("assigned_role_id", "7");
      payload.append("status",           "pending");
      payload.append("form_data",        JSON.stringify({ ...form, ...rubrosFlat }));

      if (files.minuta_contrato)
        payload.append("minuta_contrato", files.minuta_contrato, files.minuta_contrato.name);
      if (files.rut_beneficiario)
        payload.append("rut_beneficiario", files.rut_beneficiario, files.rut_beneficiario.name);

      const response = await fetch(
        apiConfig.getUrl("/api/presupuesto/solicitudes/index.php"),
        { method: "POST", credentials: "include", headers: { Accept: "application/json" }, body: payload }
      );

      const text = await response.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch { throw new Error(text || "Respuesta inválida del servidor."); }
      if (!response.ok || data?.ok === false)
        throw new Error(data?.error || data?.message || "No se pudo enviar la solicitud RP.");

      alert("Solicitud RP enviada correctamente a Presupuesto.");
      navigate("/otras-necesidades-cdp-rp");
    } catch (error) {
      console.error(error);
      alert(error.message || "Error enviando solicitud RP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Formulario RP</h1>
        <button type="button" onClick={() => navigate("/otras-necesidades-cdp-rp")} style={styles.backButton}>
          ← Volver al menú
        </button>

        <form onSubmit={handleSubmit} style={styles.form}>
          <Input label="1. Correo electrónico institucional *" name="correo" type="email" value={form.correo} onChange={handleChange} required />
          <FileInput label="2. Minuta de contrato PDF / resolución / factura / soporte legalización caja menor *" name="minuta_contrato" onChange={handleFile} required />
          <FileInput label="3. RUT beneficiario PDF" name="rut_beneficiario" onChange={handleFile} />
          <Select label="4. Tipo de contrato *" name="tipo_contrato" value={form.tipo_contrato} onChange={handleChange} options={TIPOS_CONTRATO} required />
          <Select label="5. Dependencia *" name="dependencia" value={form.dependencia} onChange={handleChange} options={DEPENDENCIAS} required />
          <Input label="6. Documento beneficiario *" name="documento_beneficiario" type="number" value={form.documento_beneficiario} onChange={handleChange} required />
          <Input label="7. Nombre beneficiario *" name="nombre_beneficiario" value={form.nombre_beneficiario} onChange={handleChange} required />
          <Textarea label="8. Objeto del contrato / encabezado de la resolución / descripción del gasto *" name="objeto" value={form.objeto} onChange={handleChange} required />
          <Input label="9. Número de contrato / resolución / factura *" name="numero_contrato_resolucion_factura" value={form.numero_contrato_resolucion_factura} onChange={handleChange} required />
          <Input label="10. Fecha del contrato / resolución / factura *" name="fecha_contrato_resolucion_factura" type="date" value={form.fecha_contrato_resolucion_factura} onChange={handleChange} required />
          <Input label="11. Valor total del contrato / resolución / factura *" name="valor_total" type="number" value={form.valor_total} onChange={handleChange} required />
          <Select label="12. Centro de costos *" name="centro_costos" value={form.centro_costos} onChange={handleChange} options={CENTROS_COSTOS} required />

          {/* ── Disponibilidades y rubros ── */}
          <div>
            <h2 style={styles.subtitle}>Disponibilidades y rubros presupuestales</h2>

            {/* Pestañas */}
            <div style={styles.tabBar}>
              {rubros.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setActiveRubro(i)}
                  style={{ ...styles.tab, ...(activeRubro === i ? styles.tabActive : {}) }}
                >
                  Rubro {i + 1}
                </button>
              ))}
              {rubros.length < 9 && (
                <button type="button" onClick={addRubro} style={styles.tabAdd}>
                  + Agregar rubro
                </button>
              )}
            </div>

            {/* Panel del rubro activo */}
            {rubros.map((rubro, i) => (
              <div key={i} style={{ display: activeRubro === i ? "block" : "none" }}>
                <div style={styles.group}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={styles.groupTitle}>Rubro {i + 1}</h3>
                    {rubros.length > 1 && (
                      <button type="button" onClick={() => removeRubro(i)} style={styles.removeBtn}>
                        🗑 Eliminar rubro
                      </button>
                    )}
                  </div>

                  <Input
                    label={`Disponibilidad${i === 0 ? " *" : ""}`}
                    value={rubro.disponibilidad}
                    onChange={(e) => handleRubroChange(i, "disponibilidad", e.target.value)}
                    type="number"
                    required={i === 0}
                  />
                  <Input
                    label={`Resumido rubro presupuestal${i === 0 ? " *" : ""}`}
                    value={rubro.resumido_rubro}
                    onChange={(e) => handleRubroChange(i, "resumido_rubro", e.target.value)}
                    type="number"
                    required={i === 0}
                  />
                  <Input
                    label={`Valor${i === 0 ? " *" : ""}`}
                    value={rubro.valor}
                    onChange={(e) => handleRubroChange(i, "valor", e.target.value)}
                    type="number"
                    required={i === 0}
                  />
                </div>
              </div>
            ))}
          </div>

          <div style={styles.actions}>
            <button type="button" onClick={() => navigate("/otras-necesidades-cdp-rp")} style={styles.secondary}>
              Volver
            </button>
            <button type="submit" disabled={loading} style={styles.primary}>
              {loading ? "Enviando..." : "Enviar RP a Presupuesto"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <label style={styles.label}>
      {label}
      <input {...props} style={styles.input} />
    </label>
  );
}

function Select({ label, options, ...props }) {
  return (
    <label style={styles.label}>
      {label}
      <select {...props} style={styles.input}>
        <option value="">Selecciona la respuesta</option>
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </label>
  );
}

function Textarea({ label, ...props }) {
  return (
    <label style={styles.label}>
      {label}
      <textarea {...props} rows={4} style={styles.textarea} />
    </label>
  );
}

function FileInput({ label, ...props }) {
  return (
    <label style={styles.label}>
      {label}
      <input {...props} type="file" accept="application/pdf" style={styles.input} />
    </label>
  );
}

const styles = {
  page: { minHeight: "100vh", background: "#f7f8fa", padding: "32px 16px", boxSizing: "border-box", overflowX: "hidden", width: "100%" },
  card: { width: "100%", maxWidth: "900px", margin: "0 auto", background: "#fff", borderRadius: "16px", padding: "28px", border: "1px solid #e5e7eb", boxShadow: "0 8px 24px rgba(0,0,0,0.08)", boxSizing: "border-box", overflow: "hidden" },
  title: { marginTop: 0, marginBottom: 24, color: "#1e3a8a", fontSize: "36px", fontWeight: 800 },
  subtitle: { marginTop: 0, marginBottom: 12, color: "#111827", fontSize: "22px", fontWeight: 700 },
  form: { width: "100%", display: "grid", gap: "16px", boxSizing: "border-box" },
  label: { width: "100%", display: "grid", gap: "6px", fontWeight: 600, color: "#374151", boxSizing: "border-box" },
  input: { width: "100%", maxWidth: "100%", boxSizing: "border-box", padding: "13px 14px", borderRadius: "10px", border: "1px solid #d1d5db", fontSize: "14px", background: "#fff", outline: "none" },
  textarea: { width: "100%", maxWidth: "100%", minHeight: "120px", boxSizing: "border-box", padding: "13px 14px", borderRadius: "10px", border: "1px solid #d1d5db", fontSize: "14px", resize: "vertical", background: "#fff", outline: "none" },
  group: { width: "100%", boxSizing: "border-box", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "16px", background: "#fafafa", display: "grid", gap: "12px", overflow: "hidden" },
  groupTitle: { margin: 0, color: "#1f2937", fontSize: "18px", fontWeight: 700 },
  actions: { width: "100%", display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "20px", flexWrap: "wrap" },
  primary: { background: "#166534", color: "#fff", border: "none", padding: "12px 18px", borderRadius: "10px", cursor: "pointer", fontWeight: 700, minWidth: "180px" },
  secondary: { background: "#e5e7eb", color: "#111827", border: "none", padding: "12px 18px", borderRadius: "10px", cursor: "pointer", fontWeight: 700, minWidth: "120px" },
  backButton: { background: "#e5e7eb", color: "#111827", border: "none", padding: "10px 14px", borderRadius: "10px", cursor: "pointer", fontWeight: 700, marginBottom: "20px", width: "fit-content" },
  tabBar: { display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "12px" },
  tab: { padding: "6px 14px", borderRadius: "9999px", border: "1px solid #d1d5db", background: "#f3f4f6", color: "#374151", fontSize: "0.85rem", fontWeight: 600, cursor: "pointer" },
  tabActive: { background: "#166534", color: "white", border: "1px solid #166534" },
  tabAdd: { padding: "6px 14px", borderRadius: "9999px", border: "1px dashed #6b7280", background: "white", color: "#166534", fontSize: "0.85rem", fontWeight: 700, cursor: "pointer" },
  removeBtn: { background: "#fee2e2", color: "#b91c1c", border: "none", padding: "5px 10px", borderRadius: "8px", fontSize: "0.8rem", fontWeight: 700, cursor: "pointer" },
};